import { Box, Button, IconButton, IconButtonProps, Text, useColorModeValue } from "@chakra-ui/react";
import { CZ, GB } from "country-flag-icons/react/3x2";
import { useTranslation } from "react-i18next";

export function LanguageToggle({ ...rest }: IconButtonProps) {
    const { i18n } = useTranslation();

    const textColor = useColorModeValue("gray.900", "gray.50");

    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang);
    };

    switch (i18n.language) {
        case "en":
            return (
                <Button
                    size="lg"
                    color={textColor}
                    justifyContent="flex-start"
                    variant="link"
                    onClick={() => changeLanguage("cs")}
                    _focus={{
                        color: textColor,
                    }}
                    _hover={{
                        textDecoration: "none",
                    }}
                    {...rest}
                >
                    <Box as="span" display="inline-flex" w={5} mr={2} aria-hidden>
                        <CZ />
                    </Box>
                    <Text fontSize="sm" fontWeight={"medium"}>
                        CZ
                    </Text>
                </Button>
            );

        case "cs":
            return (
                <Button
                    size="lg"
                    color={textColor}
                    justifyContent="flex-start"
                    variant="link"
                    onClick={() => changeLanguage("en")}
                    _focus={{
                        color: textColor,
                    }}
                    _hover={{
                        textDecoration: "none",
                    }}
                    {...rest}
                >
                    <Box as="span" display="inline-flex" w={5} mr={2} aria-hidden>
                        <GB />
                    </Box>
                    <Text fontSize="sm" fontWeight={"medium"}>
                        EN
                    </Text>
                </Button>
            );
    }

    // This should not happen :D
    return <IconButton size="lg" variant="ghost" icon={<CZ />} p={3} onClick={() => changeLanguage("cs")} {...rest} />;
}
